import axios from 'axios';
import store from '../store';

function deleteRoute (routeId) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.delete('api/client/' + currentClientId + '/route/' + routeId);
}

function deleteRouteTopic (currentRoute, topicId) {
  return axios.delete('api/deleteRouteTopic/currentRoute/' + currentRoute + '/topicId/' + topicId);
}

function getCopyName (name) {
  return axios.post('api/client/getCopyName/', {
    name: name
  });
}

function adChannelIdToARoute (routeId, channelId, tourId) {
  return axios.post('api/client/adChannelIdToARoute/', {
    routeId: routeId,
    channelId: channelId,
    tourId: tourId
  });
}

function updatePriorityForRoutes (data) {
  return axios.post('api/client/updatePriorityRoutes', data);
}
export {
  deleteRoute,
  getCopyName,
  adChannelIdToARoute,
  deleteRouteTopic,
  updatePriorityForRoutes
};



// WEBPACK FOOTER //
// ./src/services/RouteService.js